/* eslint-disable no-console */
import React from 'react';
import ArrowForward from '@material-ui/icons/ArrowForward';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
// eslint-disable-next-line import/no-extraneous-dependencies
import clsx from 'clsx';
import { useGlobal } from '@rcg/ui-react';

import useStyles from './index.style';
import { formatTime } from '../../commons/utils';

const getActivityDays = (acum, curr) => {
  let activityDays;
  if (typeof acum[acum.length - 1].number === 'number') {
    activityDays = `${acum[acum.length - 1].number}-${curr.number}`;
  } else {
    activityDays = `${acum[acum.length - 1].number.split('-')[0]}-${curr.number}`;
  }
  return activityDays;
};

const ItineraryComponent = ({
  itinerary,
  className,
  style,
  paymentOrigin,
  bookingId,
  ...others
}) => {
  const {
    renderContent,
    data: { localizedDayjs },
  } = useGlobal();
  const classes = useStyles();
  const pretourDays = itinerary?.preTour?.duration || 0;
  const arrivalDate = localizedDayjs(itinerary.sailDate).add(
    itinerary.totalNights - pretourDays,
    'days',
  );
  const getAllAtivities = (days) => {
    return days
      .map((day) => {
        if (day.ports.length > 1) {
          return day.ports.map((port) => ({
            number: day.number,
            type: day.type,
            __typename: day.__typename,
            ports: [port],
          }));
        }
        return day;
      })
      .flat();
  };

  const reducedItineraryDays = getAllAtivities(itinerary.days).reduce((acum, curr) => {
    if (
      acum.length !== 0 &&
      acum[acum.length - 1].ports[0].activity === curr.ports[0].activity &&
      acum[acum.length - 1].ports[0].port.code === curr.ports[0].port.code
    ) {
      // eslint-disable-next-line no-param-reassign
      acum[acum.length - 1].number = getActivityDays(acum, curr);
    } else {
      acum.push(curr);
    }
    return acum;
  }, []);

  return (
    <Container
      style={style}
      maxWidth="sm"
      data-testid="itinerary"
      {...others}
      className={clsx(classes.itinerary, classes.card, className)}>
      <Typography className={classes.h1}>
        {renderContent('itineraryDetailsAmend', 'Itinerary Details')}
      </Typography>
      <div className={!paymentOrigin ? classes.itInfoWrapper : classes.itInfoWrapperPayment}>
        <Typography>
          {renderContent('itineraryReservationNo', 'Reservation No')}{' '}
          <span className="reservationNumber">{bookingId}</span>
        </Typography>

        <Box className={classes.itInfo}>
          <Box component="span">
            {renderContent('itineraryBookingAmendSailingFrom', 'Sailing from')}{' '}
          </Box>
          <Box component="span">{itinerary.departurePort.name},</Box>
          {itinerary.departurePort.region && (
            <Box component="span"> {itinerary.departurePort.region} </Box>
          )}
          <Box component="span">
            {renderContent('itineraryBookingAmendOnboardConnector', 'onboard')}{' '}
          </Box>
          <Box component="span">{itinerary.ship.name}</Box>
        </Box>
      </div>

      <Box className={classes.itInlineDate}>
        <Box component="span" className="from">
          {localizedDayjs(itinerary.sailDate).format('MMM D, YYYY')}
        </Box>
        <ArrowForward />
        <Box component="span" className="to">
          {localizedDayjs(arrivalDate).format('MMM D, YYYY')}
        </Box>
      </Box>
      {itinerary.days && (
        <Paper className={classes.itList}>
          <div className={classes.tableWrapper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className="day">
                    {reducedItineraryDays.length !== 0 &&
                      renderContent('itineraryBookingAmendDay', 'Day')}
                  </TableCell>
                  <TableCell className="port">
                    {reducedItineraryDays.length !== 0 &&
                      renderContent('itineraryBookingAmendPort', 'Port')}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {reducedItineraryDays.map((value) => (
                  <TableRow key={value.number}>
                    <TableCell className="day">{value.number}</TableCell>
                    <TableCell className="port">
                      <Box component="span" className="city">
                        {value.ports[0].port.name}
                        {value.ports[0].port.region && ','} {value.ports[0].port.region}
                      </Box>
                      <Box className="info-obx">
                        <Box component="p" className="info">
                          {renderContent(
                            `itineraryBookingAmend${value.ports[0].activity?.toUpperCase()}`,
                            value.ports[0].activity,
                          )}{' '}
                        </Box>{' '}
                        <Box data-testid="time-format" component="p" className="time">
                          {value.ports[0].arrivalTime ? formatTime(value.ports[0].arrivalTime) : ''}
                          {value.ports[0].arrivalTime && value.ports[0].departureTime ? ' - ' : ''}
                          {value.ports[0].departureTime
                            ? formatTime(value.ports[0].departureTime)
                            : ''}
                        </Box>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </Paper>
      )}
    </Container>
  );
};
ItineraryComponent.propTypes = {
  itinerary: PropTypes.shape({}),
  className: PropTypes.string,
  style: PropTypes.shape({}),
  paymentOrigin: PropTypes.string,
  bookingId: PropTypes.string,
};

export default ItineraryComponent;
